import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Component } from "@angular/core";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";

import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";

export interface FaActionIcon {
  icon: IconDefinition;
  action: () => void;
  css_classes: string;
  tooltip?: string;
}

@Component({
  selector: "ag-grid-fa-symbol-link-renderer",
  template: `
    <div style="display: inline-flex; flex-direction: row; width: 100%;">
      @for (action_icon of actionIcons; track action_icon) {
        <button
          [style.margin-left]="actionIcons.indexOf(action_icon) == 0 ? 'auto' : '0'"
          [style.margin-right]="actionIcons.indexOf(action_icon) == actionIcons.length - 1 ? '0' : '4px'"
          class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost"
          [tooltip]="action_icon.tooltip"
          (click)="action_icon.action(); $event.stopPropagation()"
        >
          <fa-icon [icon]="action_icon.icon"></fa-icon>
        </button>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
  imports: [FaIconComponent, TooltipModule],
  standalone: true,
})
export class AgGridFAActionSymbolRenderer implements ICellRendererAngularComp {
  actionIcons: FaActionIcon[] = [];

  agInit(params: ICellRendererParams<{ actions: FaActionIcon[] }, FaActionIcon[], any>): void {
    this.actionIcons = params.value;
  }

  refresh(params: ICellRendererParams<{ actions: FaActionIcon[] }, FaActionIcon[], any>): boolean {
    this.actionIcons = params.value;
    return true;
  }
}
